import { render, staticRenderFns } from "./DeadlineModification.vue?vue&type=template&id=21b916bf"
import script from "./DeadlineModification.vue?vue&type=script&lang=ts"
export * from "./DeadlineModification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports